const docSubDetailFormStyle = theme => ({
	detailInformation: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 130),
		overflowY: "auto",
		overflowX: "hidden",
	},

	buttonMenu: {
		'& > *': {
			marginRight: theme.spacing(1),
		},
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},

	textRoot: {
		'& .MuiTextField-root': {
			marginTop: theme.spacing(2),
		},
	},

	itemRoot: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},

	itemText: {
		display: "inline",
		color: "blue"
	},

	reasonText: {
		display: "inline",
		color: "red"
	},

	divider: {
		marginBottom: theme.spacing(2),
	},

	datePickerField: {
		marginBottom: theme.spacing(0),
		width: '100%',
	},


	webviewer: {
		height: window.outerHeight - (window.outerHeight - window.innerHeight + 130)
	},


	checkboxArea: {
		marginTop: theme.spacing(2),
		paddingLeft: theme.spacing(1.5),
		paddingRight: theme.spacing(1.5),
	},

	requireErrorMsg: {
		marginTop: theme.spacing(0.5),
		marginLeft: theme.spacing(2)
	}

})


export {docSubDetailFormStyle}